// extracted by mini-css-extract-plugin
export var articleWrapper = "n_pF";
export var articleText = "n_pG g_fy g_dw";
export var header = "n_pH g_b5 g_bD";
export var headerImageWrapper = "n_pJ g_cl g_b6 g_cg g_cf g_cb g_ch g_cn g_cV";
export var headerGradient = "n_pK g_cl g_b6 g_cg g_cf g_cb g_ch";
export var headerGradientOverlay = "n_pL g_cl g_b6 g_cg g_cf g_cb g_ch";
export var headerContentWrapper = "n_pM g_cD g_cS g_cH g_cM g_cp g_b5";
export var headerContentWrapperAlt = "n_pN g_cD g_cS g_cH g_cM g_cp g_b5";
export var contentWrapper = "n_pP g_bD";
export var dateTag = "n_pQ g_dj g_dv g_ft g_bD";
export var icon1 = "n_pR g_dS";
export var icon2 = "n_pS g_dS g_dM";
export var tagBtn = "n_pT g_c4 g_dH g_fs g_fF";
export var headerText = "n_pV g_bD g_dj g_dw g_cZ";
export var center = "n_pW g_fz";
export var videoIframeStyle = "n_pX g_f3 g_bD g_bP g_cC g_c4 g_bY";
export var articleImageWrapper = "n_pY g_dw g_b5";
export var articleImageWrapperIcon = "n_pZ g_dw g_b5";
export var articleRow = "n_p0 g_cH";
export var quoteWrapper = "n_hH g_cG g_cS g_dw";
export var quoteBar = "n_p1 g_bP";
export var quoteText = "n_p2";
export var authorBox = "n_p3 g_bD";
export var authorRow = "n_p4 g_cH g_cZ g_dC";
export var separator = "n_p5 g_bD";
export var line = "n_gh g_bD g_gh g_d1 g_dC";
export var authorImage = "n_l4 g_db g_b5 g_bD g_dx";
export var authorText = "n_p6 g_dl g_dx";
export var masonryImageWrapper = "n_p7";
export var bottomSeparator = "n_p8 g_bD g_dC";
export var linksWrapper = "n_p9 g_dl g_fy";
export var comments = "n_qb g_cH g_dC";
export var sharing = "n_qc g_cD g_cH g_cM";
export var shareText = "n_qd g_bD g_fz";
export var icon = "n_qf";
export var customRow = "n_qg g_cH g_b5";
export var text = "n_qh";
export var SubtitleSmall = "n_qj";
export var SubtitleNormal = "n_qk";
export var SubtitleLarge = "n_ql";